'use client';

import { c as _c } from "react/compiler-runtime";
import { MessageBox } from '@7f-ui/components/message-box/message-box';
import { experienceFormSubject } from '@data-access/lib/gql/data/experience-form-subject';
import { useRouter } from 'next/navigation';
type AppExperienceRequestDateBoxProps = {
  publicId: number;
};
export function AppExperienceRequestDateBox(t0) {
  const $ = _c(6);
  const {
    publicId
  } = t0;
  const router = useRouter();
  const requestHref = `/service/anfrageformular-erlebnisse/?experienceId=${publicId}&subject=${experienceFormSubject.APPOINTMENT_REQUEST}`;
  let t1;
  if ($[0] !== requestHref || $[1] !== router) {
    t1 = {
      label: "Termin anfragen",
      onClick: () => router.push(requestHref)
    };
    $[0] = requestHref;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div>Kein passender Termin dabei?<br />Hier individuell anfragen.</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <MessageBox type="success" action={t1}>{t2}</MessageBox>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}